import { render, staticRenderFns } from "./rating-header.vue?vue&type=template&id=23d82980"
import script from "./rating-header.vue?vue&type=script&lang=ts"
export * from "./rating-header.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports